import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'

import NewCompany from '../components/modals/NewCompany'
import TranslationServicesService from '../services/TranslationServicesService'

export default withRouter(({ match, history }) => {
  const { id } = match.params
  const [model, setModel] = useState(null)
  const [isLoading, setIsLoading] = useState(!!id)

  useEffect(() => {
    if (id) {
      TranslationServicesService.get(id)
        .then(data => {
          setModel(data)
          setIsLoading(false)
        })
        .catch(err => {
          console.error(err)
          setIsLoading(false)
        })
    }
  }, [id])

  const handleSave = (model, isUpdate) => {
    if (isUpdate) {
      return TranslationServicesService.update(model)
    } else {
      return TranslationServicesService.create(model)
    }
  }

  const handleSaveSuccess = () => {
    history.push('/library/translation-services')
  }

  const handleClose = () => {
    history.push('/library/translation-services')
  }

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <div className="container mt-4">
      <Helmet
        title={id ? `Edit Translation Service ${model?.name ? `- ${model.name}` : ''}` : 'Add Translation Service'}
      />
      <NewCompany
        oldModel={model}
        onSave={handleSave}
        onSaveSuccess={handleSaveSuccess}
        onClose={handleClose}
        title="Translation Service"
      />
    </div>
  )
})
